import Commons from './Common';
import Global from './Global';

export const apiRequest = async (method = 'post', path, params) => {
  const url = `${Global.base.useUrl}${path}`;
  const { data } = await Commons.Axios(method, url, params);
  return data;
};
